var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3557 0C13.4376 0 15.9714 2.04023 16.1 4.62543H16.0699C16.0735 4.70058 16.0564 4.77541 16.0198 4.84407H16.1994C17.5989 4.84407 19.0645 5.66127 19.6521 7.63406L19.716 7.86684L20.6002 13.8683C21.2365 17.6961 18.7507 19.3058 15.3596 19.374L15.1322 19.3763H5.5988C2.15254 19.3763 -0.503073 18.3183 0.0808228 14.1288L0.12064 13.8683L1.01503 7.86684C1.45606 5.74234 2.93664 4.90438 4.36323 4.84723L4.52146 4.84407H4.61136C4.5962 4.77175 4.5962 4.69776 4.61136 4.62543C4.73997 2.04023 7.27373 0 10.3557 0ZM7.01153 8.06953C6.45021 8.06953 5.99517 8.46409 5.99517 8.95081C5.99517 9.43752 6.45021 9.83208 7.01153 9.83208C7.57285 9.83208 8.02788 9.43752 8.02788 8.95081L8.01997 8.84026C7.95725 8.40573 7.52967 8.06953 7.01153 8.06953ZM13.6687 8.06953C13.1073 8.06953 12.6523 8.46409 12.6523 8.95081C12.6523 9.43752 13.1073 9.83208 13.6687 9.83208C14.23 9.83208 14.685 9.43752 14.685 8.95081C14.685 8.46409 14.23 8.06953 13.6687 8.06953ZM10.3106 1.26177C8.09787 1.26177 6.3041 2.76773 6.3041 4.62543C6.31926 4.69776 6.31926 4.77175 6.3041 4.84407H14.3672C14.3352 4.77426 14.3182 4.70023 14.3171 4.62543C14.3171 2.76773 12.5233 1.26177 10.3106 1.26177Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1688:9470",
    x1: 10.35,
    y1: 0,
    x2: 10.35,
    y2: 19.3763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.1ad40bcfe2cbbf004af26f0f39bbec2b.svg";
export { ForwardRef as ReactComponent };